import React, { useState, useEffect } from "react";
import { Input, Select, DatePicker, Checkbox, Button } from "antd";
import BookingModal from "./booking_document_modal/BookingDocumentModal";
import AddBusNewModal from "../../job_detail/add_bus_modal/AddBusNewModal";
//AddBusModal
import BusTable from "./bus_table/BusTable";
import Api from "../../../../services/ServiceApi";
import moment from "moment";
// import Cookies from "js-cookie";
import XLSX from 'xlsx';
const BusManagement = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [tabStatus, setTabStatus] = useState("All");
  const [bookedData, setBookedData] = useState([]);
  // const [searchData, setSearchData] = useState("");
  const [busesData, setBusesData] = useState([]);
  const [bookedAmount, setBookedAmount] = useState(0);
  const [isBookingModalVisible, setBookingModalVisible] = useState(false);
  const [isAddBusModalVisible, setVisibleAddBusModal] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [selBusGroup, setSelBusGroup] = useState("");
  const [selBusType, setSelBusType] = useState("");
  const [selAdsArea, setSelAdsArea] = useState([]);
  const [selTechnique, setSelTechnique] = useState([]);
  const [selCategory, setSelCategory] = useState("");
  const [selDateType, setSelDateType] = useState("");
  const [adsArea, setadsArea] = useState([]);
  const [MasterTechnique, setMasterTechnique] = useState([]);
  const [Technique, setTechnique] = useState([]);
  const [MasteradsArea, setMasteradsArea] = useState([]);
  const [original_data, setoriginal_data] = useState([]);
  const [countJob, setcountJob] = useState(0);
  const [initData, setInitData] = useState({
    busGroupData: [],
    busTypeData: [],
    adsAreaData: [],
    busDateData: [],
    busSearchData: [],
    techniqueData: [],
  });
  useEffect(() => {

    Api.post("v2/getAdsBus", {
    })
      .then((res) => {
        for (let i = 0; i < res.data.data.length; i++) {
          res.data.data[i]["status_checkbox"] = false;
        }
        setBusesData(res.data.data)
        setFilterData(res.data.data)
        setoriginal_data(res.data.data);
      })
      .catch((e) => {
        console.log(e);
      });

    Api.post("get_query_group_list", {
      "company_id": "1"
      , "operator_id": "3"
      , "project_id": "1"
      , "query_id": "6,7,9,10,11,12"
      ,"query_module" : "bus"
      , "param_text": ""
      , "where_cond": ""
    }).then((res) => {
      var adsArea_orginal = {};
      var Technique_orginal = {};
      const data = res.data.data
      for (let i = 0; i < data.filter_ads_area.length; i++) {
        adsArea_orginal[data.filter_ads_area[i].filter_value] = false;
      }
      for (let i = 0; i < data.filter_technique.length; i++) {
        Technique_orginal[data.filter_technique[i].filter_value] = false;
      }
      let temp = {
        busGroupData: data.bus_group_list,
        busTypeData: data.bus_type_list,
        adsAreaData: data.filter_ads_area,
        busDateData: data.filter_bus_mgt_date,
        busSearchData: data.filter_bus_mgt_search,
        techniqueData: data.filter_technique,
        original_data: data
      }

      setMasteradsArea(adsArea_orginal);
      setMasterTechnique(Technique_orginal);
      setInitData(temp)

    })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {

    setBusesData(busesData)
    // console.log('useEffect busesData', busesData);

  }, { busesData });

  useEffect(() => {

    setFilterData(filterData)
    // console.log('useEffect filterData', filterData);

  }, { filterData });

  useEffect(() => {

    setSelBusGroup(selBusGroup)
    // console.log('useEffect selBusGroup', selBusGroup);

  }, { selBusGroup });

  useEffect(() => {

    setSelBusType(selBusType)
    // console.log('useEffect selBusType', selBusType);

  }, { selBusType });

  useEffect(() => {

    setSelAdsArea(selAdsArea)
    // console.log('useEffect selAdsArea', selAdsArea);

  }, { selAdsArea });

  useEffect(() => {

    setSelTechnique(selTechnique)
    // console.log('useEffect selTechnique', selTechnique);

  }, { selTechnique });

  useEffect(() => {

    setSelTechnique(selTechnique)
    // console.log('useEffect selTechnique', selTechnique);

  }, { selTechnique });

  useEffect(() => {

    setSelDateType(selDateType)
    // console.log('useEffect selDateType', selDateType);

  }, { selDateType });


  useEffect(() => {

    setInitData(initData)
    // console.log('useEffect setInitData',initData);

  }, { initData });

  let searchInput = {
    userInput: "",
    detailInput: "",
    teamChoice: "",
  };
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const tab = [
    { text: "All" },
    { text: "Available" },
    { text: "Not Available" },
  ];

  const searchFilter = (sel, val) => {

    let tempFilteredData = filterData

    if (sel === "bus_group") {
      tempFilteredData = [];
      tempFilteredData = original_data.filter((i) => i.bus_group_id === val)
      setFilterData(tempFilteredData)
    }
    if (sel === "bus_type") {
      tempFilteredData = original_data.filter((i) => i.bus_type_id === val)
      setFilterData(tempFilteredData)
    }
    if (sel === "ads_area") {
      var defaultFlase = 0;
      var setdata = [];
      var countAds = 0;
      for (const [key, value] of Object.entries(MasteradsArea)) {
        if (value) {
          const filterAds = original_data.filter((i) => i[key.toLowerCase()] === 1);
          if (filterAds != 0) {
            setdata.push(filterAds);
          }
          countAds++;
        }
        else {
          defaultFlase++;
        }
        if (defaultFlase === Object.keys(MasteradsArea).length) {
          setdata = original_data;
          countAds = 0;
        }
      }
      setadsArea(countAds === 0 ? [] : ["Ads Area " + countAds]);
      setFilterData(setdata);
    }
    if (sel === "technique") {
      var defaultFlase = 0;
      var setdata = [];
      var countTec = 0;
      for (const [key, value] of Object.entries(MasterTechnique)) {
        if (value) {
          const filterTec = original_data.filter((i) => i[key.toLowerCase()] === 1);
          if (filterTec != 0) {
            setdata.push(filterTec);
          }
          countTec++;
        }
        else {
          defaultFlase++;
        }
        if (defaultFlase === Object.keys(MasterTechnique).length) {
          setdata = original_data;
          countTec = 0;
        }
      }
      setTechnique(countTec === 0 ? [] : ["Technique " + countTec]);
      setFilterData(setdata);
    }
  }
  const searchDetail = (value) => {
    console.log(value)
    let tempFilteredData = [];
    if (value === "") {
      tempFilteredData = original_data;
    }
    else {
      if (selCategory === "bus_line.bus_line_name") {
        tempFilteredData = original_data.filter((i) => i.bus_line_name === value)
      }
      if (selCategory === "bus.bus_no") {
        tempFilteredData = original_data.filter((i) => i.bus_no === value)
      }
      if (selCategory === "bus.license_plate") {
        tempFilteredData = original_data.filter((i) => i.license_plate === value)
      }
      if (selCategory === "garage.garage_name") {
        tempFilteredData = original_data.filter((i) => i.garage_name === value)
      }
      if (selCategory === "model.model_name") {
        tempFilteredData = original_data.filter((i) => i.model_name === value)
      }

      if (selBusGroup) {
        tempFilteredData = tempFilteredData.filter((i) => i.bus_group_id === selBusGroup)
      }

      if (selBusType) {
        tempFilteredData = tempFilteredData.filter((i) => i.bus_type_id === selBusType)
      }

      if (selAdsArea.length > 0) {
        // console.log('area f');
        if (selAdsArea[1] === "FW") {
          tempFilteredData = tempFilteredData.filter((i) => i.fw === true)
        }
        if (selAdsArea[1] === "HW") {
          tempFilteredData = tempFilteredData.filter((i) => i.hw === true)
        }
        if (selAdsArea[1] === "QW") {
          tempFilteredData = tempFilteredData.filter((i) => i.qw === true)
        }
        if (selAdsArea[1] === "Special") {
          tempFilteredData = tempFilteredData.filter((i) => i.special === true)
        }
        if (selAdsArea[1] === "IB") {
          tempFilteredData = tempFilteredData.filter((i) => i.ib === true)
        }
        if (selAdsArea[1] === "HG") {
          tempFilteredData = tempFilteredData.filter((i) => i.hg === true)
        }
        if (selAdsArea[1] === "LCD") {
          tempFilteredData = tempFilteredData.filter((i) => i.lcd === true)
        }
      }

      if (selTechnique.length > 0) {
        if (selTechnique[1] === "2D") {
          tempFilteredData = tempFilteredData.filter((i) => i["2D"] === true)
        }
        if (selTechnique[1] === "3D") {
          tempFilteredData = tempFilteredData.filter((i) => i["3D"] === true)
        }
        if (selTechnique[1] === "LED") {
          tempFilteredData = tempFilteredData.filter((i) => i.led === true)
        }
        if (selTechnique[1] === "Reflective_film") {
          tempFilteredData = tempFilteredData.filter((i) => i.reflective_film === true)
        }
      }
    }

    setFilterData(tempFilteredData)
  };
  const FilterDate = (value) => {
    if (value != null) {
      if (selDateType === "internal_ad_start,external_ad_start") {
        const filteredItemsNotnull = original_data.filter((data) => data.internal_ad_start !== null || data.external_ad_start !== null);
        const filteredItems = filteredItemsNotnull.filter((item) =>
          (moment(converDate(item.internal_ad_start)).isBetween(converDate(value[0]),
            moment(converDate(value[1])).add(1, 'days')) === true) ||
          (moment(converDate(item.external_ad_start)).isBetween(converDate(value[0]),
            moment(converDate(value[1])).add(1, 'days')) === true)
        )
        setFilterData(filteredItems);
      }
      if (selDateType === "internal_ad_end,external_ad_end") {
        const filteredItemsNotnull = original_data.filter((data) => data.internal_ad_end !== null || data.external_ad_end !== null);
        const filteredItems = filteredItemsNotnull.filter((item) =>
          (moment(converDate(item.internal_ad_end)).isBetween(converDate(value[0]),
            moment(converDate(value[1])).add(1, 'days')) === true) ||
          (moment(converDate(item.external_ad_end)).isBetween(converDate(value[0]),
            moment(converDate(value[1])).add(1, 'days')) === true)
        )
        setFilterData(filteredItems);
      }
    }
    else {
      setFilterData(original_data);
    }
  }

  const converDate = (item) => {
    if (item === null) {
      // return moment(new Date()).format("YYYY-MM-DD")
      return null
    }
    else {
      if (moment(item, "DD/MM/YYYY").format("YYYY-MM-DD") === "Invalid date") {
        return moment(item).format("YYYY-MM-DD")
      }
      else {
        return moment(item, "DD/MM/YYYY").format("YYYY-MM-DD")
      }
    }


  }
  const ExportExcel = () => {
    var result_array = [];
    var setHerder = {};
    const wb = XLSX.utils.book_new();
    var dataSet = {BusManagement: original_data}    ; 

    for (const [key, value] of Object.entries(dataSet)) {
      // console.log(`${key}: ${value}`);
      for (let i = 0; i < dataSet[`${key}`].length; i++) {
        for (const [key_h, value_h] of Object.entries(dataSet[`${key}`][i])) {
          setHerder[`${key_h}`] = `${key_h}`;
        }
        result_array.push(dataSet[`${key}`][i])
      }
      let binaryWS = XLSX.utils.json_to_sheet([setHerder, ...result_array], { skipHeader: true });
      XLSX.utils.book_append_sheet(wb, binaryWS, `${key}`);
      result_array = [];
      setHerder = {};
    }
    XLSX.writeFile(wb,"BusManagement.xlsx");

  }
  return (
    <div className="container-fluid">
      <div className="d-flex align-items-center justify-content-between my-2">
        <div>
          <div className="d-flex">
            <div className="mr-4">
              <Input.Group compact>
                {/* Bus Group dropdown  without choice*/}
                <Select
                  placeholder="Bus Group"
                  allowClear
                  // value="Bus Group"
                  style={{ width: "140px" }}
                  onChange={(val) => {
                    // console.log('bus group', val);

                    setSelBusGroup(val)
                    searchFilter('bus_group', val)
                  }}
                // mode="multiple"
                // allowClear
                >
                  {initData.busGroupData.map((data, index) => (
                    <Option
                      key={`busGroup_${index}`}
                      value={data.bus_group_id}
                    >
                      {data.bus_group_name}
                    </Option>
                  ))}
                </Select>
                {/* Bus Type dropdown without choice */}
                <Select
                  placeholder="Bus Type"
                  // value="Bus Type"
                  style={{ width: "140px" }}
                  allowClear
                  onChange={(val) => {
                    // console.log('bus type', val);
                    setSelBusType(val)
                    searchFilter('bus_type', val)

                  }}
                // mode="multiple"
                // allowClear
                >
                  {initData.busTypeData.map((data, index) => (
                    <Option
                      key={`busType_${index}`}
                      value={data.bus_type_id}
                    >
                      {data.bus_type_name}
                    </Option>
                  ))}

                </Select>
                {/* Ads area dropdown */}
                <Select
                  allowClear
                  mode="multiple"
                  showArrow={true}
                  showSearch={false}
                  placeholder="Ads. Area"
                  value={adsArea}
                  style={{ width: "140px" }}

                // mode="multiple"
                // allowClear
                >
                  {initData.adsAreaData.map((data, index) => (
                    <Option
                      key={index}
                    >
                      <Checkbox key={index}
                        onChange={(val) => {
                          MasteradsArea[data.filter_value] = val.target.checked;
                          searchFilter('ads_area', val)
                          setSelAdsArea(val)
                        }}
                      >{data.filter_name}</Checkbox>
                    </Option>
                  ))}

                </Select>
                {/* Technique dropdown */}
                <Select
                  allowClear
                  mode="multiple"
                  placeholder="Technique"
                  // value={<span style={{ "background": "none" }}>Technique</span>}
                  value={Technique}
                  showArrow={true}
                  showSearch={false}
                  style={{ width: "140px", "margin-right": "1rem" }}
                >
                  {initData.techniqueData.map((data, index) => (
                    <Option
                      key={index}
                    >
                      <Checkbox key={index}
                        onChange={(val) => {
                          MasterTechnique[data.filter_value] = val.target.checked;
                          searchFilter('technique', val)
                          setSelTechnique(val)
                        }}
                      >{data.filter_name}</Checkbox>
                    </Option>
                  ))}

                </Select>
                <Select
                  allowClear
                  placeholder="Line No."
                  style={{ width: "140px", "margin-right": "1rem" }}
                  onChange={(val) => {
                    // console.log(val);
                    setSelCategory(val)
                  }}
                // mode="multiple"
                // allowClear
                >
                  {initData.busSearchData.map((data, index) => (
                    <Option
                      key={`busSearch_${index}`}
                      value={data.filter_value}
                    >
                      {data.filter_name}
                    </Option>
                  ))}
                </Select>
                {/* Search */}
                <Input.Search
                  allowClear
                  placeholder="Search"
                  onSearch={(value) => searchDetail(value)}
                  // onSearch={(value) => searchFilter()}
                  style={{ width: "250px", "margin-right": "1rem" }}
                  enterButton
                />
                {/* Export button */}
                {/* <Button
                  className="btn btn-primary"
                  placement="bottomCenter"
                  icon={<DownOutlined />}
                  style={{ "margin-right": "1rem" }}
                >
                  Export
                </Button> */}
                {/* Add Bus button */}
                <button
                  className="btn btn-warning"
                  onClick={() => setVisibleAddBusModal(true)}
                >
                  <img
                    src={Api.absoluteUrl("/icon/plus.svg")}
                    className="mr-2"
                  />
                  Add Bus
                </button>
                <Button
                  className="btn btn-primary"
                  placement="bottomCenter"
                  style={{ marginRight: "1rem" }}
                  onClick={() => ExportExcel() }
                >
                  Export
                </Button>


              </Input.Group>
              {isAddBusModalVisible ? (
                <AddBusNewModal handleVisible={setVisibleAddBusModal} />
                // <AddBusModal handleVisible={setVisibleAddBusModal} />
              ) : null}
            </div>
          </div>
          <div className="d-flex">
            <Input.Group compact>
              {/* Expired Date */}
              <Select
                allowClear
                placeholder="Date"
                style={{ width: "140px", marginRight: "1rem" }}
                onChange={(val) => {
                  // console.log(val);
                  setSelDateType(val)
                }}
              // mode="multiple"
              // allowClear
              >
                {initData.busDateData.map((data, index) => (
                  <Option
                    key={`busDate_${index}`}
                    value={data.filter_value}
                  >
                    {data.filter_name}
                  </Option>
                ))}
              </Select>
              {/* Range date */}
              <RangePicker
                onChange={(e) => {
                  FilterDate(e)
                }}
                allowClear
                style={{
                  marginLeft: "10px",
                  color: "#000F9F",
                  marginRight: "20px",
                }}
              />
            </Input.Group>
          </div>
        </div>
      </div>
      <div className="card-table-ma">
        <div style={{ padding: "20px" }} className="row">
          <div className="col-9">
            <ul className="nav">
              {tab.map((item, index) => (
                <li key={index} className="nav-item fs-14 font-mont-sb mr-1">
                  <a
                    className={
                      activeTab === index ? "nav-link active" : "nav-link"
                    }
                    onClick={() => {
                      setTabStatus(item.text);
                      setActiveTab(index);
                    }}
                  >
                    {item.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-3">
            <div className="d-flex justify-content-between align-items-center ">
              <span className="font-thai-b c-bule font14">
                {/* <span>Count Job</span>  */}
              </span><div className="stat  d-flex align-items-center warning">
                <span className="font-thai-b font30 c-bule w-100 text-center ">{countJob}</span>
              </div>
            </div>
          </div>
          <div className="col-12">
            {  parseInt(localStorage.getItem("permission"))  === 1 ? 
            <button
              className="btn btn-warning"
              onClick={() => setBookingModalVisible(true)}
              style={{ margin: "10px" }}
            >
              Booking ({bookedAmount.length === undefined ? 0 : bookedAmount.length })
            </button>
            : null}
          </div>
          {isBookingModalVisible ? (
            <BookingModal
              handleVisible={setBookingModalVisible}
              bookedData={bookedAmount}
            />
          ) : (
            ""
          )}
          <BusTable
            tabStatus={tabStatus}
            setBookedData={setBookedData}
            setBookedAmount={setBookedAmount}
            busesData={filterData}
            originalData={original_data}
            setoriginal_data={setoriginal_data}
            setcountJob={setcountJob}
          // searchData={searchData}
          />
        </div>
      </div>
    </div>
  );
};

export default BusManagement;
